import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsFocusLabelModule, CmpsOpportunityItemModule } from '@cmps/ng-kit';
import { CmpsAccordionModule, CmpsUserInfoModule } from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsSingleDecimalPointModule } from '../../common/pipe/single-decimal-point';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';

import { CoachingDetailPillarOneComponent } from './pillar-one.component';
import { TranslationIdMap } from './pillar-one.i18n';

@NgModule({
    declarations: [CoachingDetailPillarOneComponent],
    imports: [
        CmpsAccordionModule,
        CmpsCommonModule,
        CmpsFocusLabelModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsOpportunityItemModule,
        CmpsSingleDecimalPointModule,
        CommonModule,
        CmpsUserInfoModule,
    ],
    exports: [CoachingDetailPillarOneComponent],
})
export class CmpsCoachingDetailPillarOneModule {}
